import api from '../../apiConfig/apiConfig';
import { Post } from '../base/baseAjax';
export default {
	analytics(param) {
		return Post({
			url: api.flowAnalysis.analytics,
			bodyParam: param,
		});
	},
};
